import { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { ChatWidget } from "./ChatWidget";
import { PageLoader } from "./PageLoader";
import { IntroOverlay } from "./IntroOverlay";
import { setLenis, scrollToTarget } from "../../lib/lenis";

export default function Layout() {
  const { pathname, hash } = useLocation();
  const [introOpen, setIntroOpen] = useState(() => !pathname.startsWith("/admin"));
  const [introRun, setIntroRun] = useState(0);
  const closeIntro = useCallback(() => { setIntroOpen(false); setIntroRun((n) => n + 1); }, []);
  const replayIntro = useCallback(() => setIntroOpen(true), []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToTarget(hash), 120);
      return () => clearTimeout(t);
    }
    scrollToTarget(0, { immediate: true, offset: 0 });
    return undefined;
  }, [pathname, hash]);

  return (
    <div className="grain min-h-screen bg-ink text-slate-100">
      <Nav />
      <main><Outlet context={{ introOpen, introRun, replayIntro }} /></main>
      <Footer />
      <ChatWidget />
      <PageLoader />
      <IntroOverlay open={introOpen} onClose={closeIntro} />
    </div>
  );
}
